"use client";

import { useState } from "react";

import { fmtIntCA } from "@/lib/format";

import type { MatrixView } from "@/app/council/_lib/alignment-data";

import { AlignmentChord } from "./AlignmentChord";

type Props = {
  committees: MatrixView[];
};

export function CommitteeTabs({ committees }: Props) {
  const [active, setActive] = useState<string>(
    committees[0]?.scope.slug ?? "",
  );
  if (committees.length === 0) return null;
  const current =
    committees.find((c) => c.scope.slug === active) ?? committees[0];
  return (
    <div>
      <div
        role="tablist"
        aria-label="Committee"
        className="flex flex-wrap gap-1 cs-mono text-xs mb-4"
      >
        {committees.map((c) => {
          const isActive = c.scope.slug === current.scope.slug;
          return (
            <button
              key={c.scope.slug}
              role="tab"
              aria-selected={isActive}
              type="button"
              onClick={() => c.scope.slug && setActive(c.scope.slug)}
              className={
                "px-2.5 py-1.5 border " +
                (isActive
                  ? "border-ink bg-ink text-bg"
                  : "border-rule text-ink-2 hover:border-ink-3")
              }
            >
              {c.scope.label} · {fmtIntCA(c.stats.n_motions)} motion
              {c.stats.n_motions === 1 ? "" : "s"}
            </button>
          );
        })}
      </div>

      <div className="mb-3 cs-mono text-xs text-ink-3 leading-relaxed">
        <span className="text-ink-2">{current.scope.label}</span>{" "}
        · {fmtIntCA(current.stats.n_meetings)} meeting
        {current.stats.n_meetings === 1 ? "" : "s"} ·{" "}
        {fmtIntCA(current.stats.n_motions)} motion
        {current.stats.n_motions === 1 ? "" : "s"} ·{" "}
        {fmtIntCA(current.stats.n_contested_motions)} contested
      </div>

      <AlignmentChord matrix={current} blocs={null} />
    </div>
  );
}
